module.exports = __webpack_public_path__ + "img/pic1.eadee9fa.png";